import { axiosPost } from '@/utils/httpUtil'
import { API_URL } from '@/utils/constant/app.constants'

/**
 * @description: httpCommCmSyCmmCommRetrieveAttFileId (첨부파일id 조회)
 * @param {object} saveFileUploadInDto 업로드 파일 저장 DTO
 */
export const httpCommCmSyCmmCommRetrieveAttFileId = (pdata) => {
  return axiosPost({
    url: API_URL + '/comm/api/cm/sy/cmm/comm/retrieve-att-file-id',
    data: pdata
  })
}

/**
 * @description: httpCommCmSyCmmCommSaveFileUpload (업로드 파일 저장)
 * @param {object} saveFileUploadInDto 업로드 파일 저장 DTO
 */
export const httpCommCmSyCmmCommSaveFileUpload = (pdata) => {
  return axiosPost({
    url: API_URL + '/comm/api/cm/sy/cmm/comm/save-file-upload',
    data: pdata,
    headers: {
      'Content-Type': 'multipart/form-data; charset=utf-8'
    }
  })
}

/**
 * @description: httpCmSyCmmCommRetrieveAttFileList (공통팝업-이미지미리보기 조회)
 * @param {string} attFileId 첨부파일ID
 * @param {string} attFileSeqno 첨부파일일련번호
 */
export const httpCmSyCmmCommRetrieveAttFileList = (param) => {
  return axiosPost({
    url: API_URL + '/comm/api/cm/sy/cmm/comm/retrieve-att-file-list',
    ...param
  })
}

/**
 * @description: httpCmSyCmmMsgRetrieveAllMsgList (메시지 목록 조회)
 */
export const httpCmSyCmmMsgRetrieveAllMsgList = (param) => {
  return axiosPost({
    url: API_URL + '/comm/api/cm/sy/cmm/msg/retrieve-all-msg-list',
    data: param,
    headers: {
      'Content-Type': 'multipart/form-data; charset=utf-8'
    }
  })
}

/**
 * @description: httpCmSyCmmCommRetrieveSysDate (시스템날짜 조회)
 */
export const httpCmSyCmmCommRetrieveSysDate = () => {
  return axiosPost({
    url: API_URL + '/comm/api/cm/sy/cmm/comm/retrieve-sys-date'
  })
}

/**
 * @description: 공휴일 조회
 * @param {string} fromYear 시작연도 (필수)
 * @param {string} toYear 종료연도 (필수)
 */
export const httpCmSyCmmCalenRetrieveHoliday = (param) => {
  return axiosPost({
    url: API_URL + '/comm/api/cm/sy/cmm/calen/retrieve-holiday',
    data: param
  })
}
